import * as utils from '@utils/form';
import { WA_BLACK, WA_TRANSPARANT } from '@constants';
import { IMAGE_SIZE } from '@api/media/constants';

export const FORM_FIELD = {
  TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Enter a title',
  },
  SUBTITLE: {
    name: 'subtitle',
    label: 'Subtitle:',
    placeholder: 'Enter a subtitle',
  },
  TABLE_CONTENT: {
    name: 'tableContent',
    label: 'Add HTML for table:',
    rules: [{ required: true, message: 'HTML is required' }],
  },
  BACKGROUND: {
    name: 'backgroundImage',
    label: 'Background image:',
    buttonText: 'CHOOSE A NEW IMAGE',
    rules: [{ required: true, message: 'Background image is required' }],
    size: IMAGE_SIZE['2000x714'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  BACKGROUND_COLOUR: {
    name: 'backgroundColour',
    label: 'Background colour:',
    colors: [WA_BLACK, WA_TRANSPARANT],
    rules: [{ required: true, message: 'Background colour is required' }],
  },
  IMAGE: {
    name: 'image',
    label: 'Background image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['2000x714'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
};
export const FORM_FIELDS = Object.values(FORM_FIELD);
